import http from 'plugins/axios';

function tenantParam(tenantId) {
  const tid =
    tenantId === undefined || tenantId === null || tenantId === '' ? 0 : tenantId;
  return `tenantId=${encodeURIComponent(tid)}`;
}

export default {
  page({ page, size, tenantId, messageSource }) {
    let url = `/la/admin/msg/channel-source/page?page=${page}&size=${size}`;
    url += `&${tenantParam(tenantId)}`;
    if (messageSource) {
      url += `&messageSource=${encodeURIComponent(messageSource)}`;
    }
    return http.get({ url });
  },
  messageSourceOptions() {
    return http.get({
      url: '/la/admin/msg/channel-source/message-source-options',
    });
  },
  tenantOptions() {
    return http.get({ url: '/la/admin/msg/channel-source/tenant-options' });
  },
  channelTypes() {
    return http.get({ url: '/la/admin/msg/channel/types' });
  },
  enabledChannels({ tenantId, channelName }) {
    let url = `/la/admin/msg/channel-source/enabled-channels?${tenantParam(tenantId)}`;
    if (channelName) {
      url += `&channelName=${encodeURIComponent(channelName)}`;
    }
    return http.get({ url });
  },
  detail(id, tenantId) {
    const tid =
      tenantId === undefined || tenantId === null || tenantId === '' ? 0 : tenantId;
    return http.get({
      url: `/la/admin/msg/channel-source/detail?id=${encodeURIComponent(id)}&${tenantParam(tid)}`,
    });
  },
  save(data) {
    return http.post({
      url: '/la/admin/msg/channel-source/save',
      data,
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/msg/channel-source/update',
      data,
    });
  },
  remove(id, tenantId) {
    return http.post({
      url: `/la/admin/msg/channel-source/delete?id=${encodeURIComponent(id)}&${tenantParam(
        tenantId,
      )}`,
    });
  },
  setBindingEnabled(id, tenantId, enabled) {
    return http.post({
      url: `/la/admin/msg/channel-source/enabled?id=${encodeURIComponent(id)}&${tenantParam(
        tenantId,
      )}&enabled=${enabled}`,
    });
  },
};
